import firebase from "firebase/app";
import { getRegionName } from "@/utils/functionsRegion";
import {RequestCode} from "@/enums/RequestCode";
import {eventBus} from "@/main";

export default {
  name: "PublishDigitalSignageDlg",
  data() {
    return {
      dialog: false,
      loading: false,
      facilitiesToSelect: [],
      selectedFacilitiesIds: [],
      resolve: null,
      parentDigitalSignageId: ''
    }
  },
  computed: {
    facilities() {
      return this.$store.state.facilityModule.facilities;
    },
    facilitiesForOrg() {
      return this.$store.state.userModule.facilitiesForOrg;
    },
    currentFacility() {
      return this.$store.state.authModule.currentFacility;
    },
    digitalSignage() {
      return this.$store.state.digitalSignageModule.currentDigitalSignage;
    },
  },
  async mounted() {
    await this.$store.dispatch("getFacilitiesForOrg");
    this.setPublishTo(this.digitalSignage);
    this.facilitiesToSelect = this.facilitiesForOrg.filter(x => x.id != this.currentFacility);
    this.parentDigitalSignageId = this.digitalSignage?.parentDigitalSignageId ? this.digitalSignage?.parentDigitalSignageId : Math.floor(new Date().getTime() / 1000)
  },
  beforeDestroy() {
    this.selectedFacilitiesIds = [];
  },
  watch: {
    digitalSignage(newValue) {
      this.setPublishTo(newValue)
    }
  },
  methods: {
    onFacilityChange(facility, isSelected) {
      if (isSelected) {
        this.selectedFacilitiesIds.push(facility.id)
      }
      else {
        this.selectedFacilitiesIds.splice(this.selectedFacilitiesIds.indexOf(facility.id), 1)
      }
    },
    setPublishTo(digitalSignage) {
      if(digitalSignage?.publishTo && digitalSignage?.publishTo.length) {
        this.selectedFacilitiesIds = [this.currentFacility, ...digitalSignage.publishTo];
      } else {
        this.selectedFacilitiesIds = [this.currentFacility];
      }
    },
    async updateCurrentDigitalSignage() {
      await firebase.app().functions(getRegionName()).httpsCallable('utils-updateOrgDocument')({
        orgId: this.$store.state.authModule.currentFacilityData.orgId,
        collectionName: 'digitalSignage',
        docId: this.$route.params.id,
        facilityId: this.$store.state.authModule.currentFacility,
        updates: {
          parentDigitalSignageId: this.parentDigitalSignageId,
          publishTo: this.selectedFacilitiesIds.filter(x => x !== this.currentFacility)
        }
      });
    },
    async unPublishFacilityDigitalSignage(facilityId) {
      const response = await firebase.app().functions(getRegionName()).httpsCallable('utils-getOrgDocuments')({
        orgId: this.$store.state.authModule.currentFacilityData.orgId,
        collectionName: 'digitalSignage',
        conditions: [{property: 'parentDigitalSignageId',condition:'==',value: this.parentDigitalSignageId}]
      });

      const digitalSignageByFacility = response.data.data
        .filter(x => x.facilityId === facilityId)
        .filter(x => x.parentDigitalSignageId === this.parentDigitalSignageId);

      if(response.data.code === RequestCode.Success && digitalSignageByFacility.length) {
        for(let i = 0; i < digitalSignageByFacility.length; i++) {
          await firebase.app().functions(getRegionName()).httpsCallable('utils-deleteOrgDocument')({
            orgId: this.$store.state.authModule.currentFacilityData.orgId,
            docId: digitalSignageByFacility[i].id,
            collectionName: 'digitalSignage'
          })
        }
      }
    },
    async publishFacilityDigitalSignage(facilityId) {
      const response = await firebase.app().functions(getRegionName()).httpsCallable('utils-getOrgDocuments')({
        orgId: this.$store.state.authModule.currentFacilityData.orgId,
        collectionName: 'digitalSignage',
        conditions: [{property: 'parentDigitalSignageId',condition:'==',value: this.parentDigitalSignageId}]
      });

      const digitalSignageByFacility = response.data.data
        .filter(x => x.facilityId === facilityId)
        .filter(x => x.parentDigitalSignageId === this.parentDigitalSignageId);

      if(response.data.code === RequestCode.Success) {
        if(digitalSignageByFacility.length) {

          for(let i = 0; i < digitalSignageByFacility.length; i++) {
            const doc = digitalSignageByFacility[i];

            await firebase.app().functions(getRegionName()).httpsCallable('utils-updateOrgDocument')({
              orgId: this.$store.state.authModule.currentFacilityData.orgId,
              collectionName: 'digitalSignage',
              docId: doc.id,
              facilityId: doc.facilityId,
              updates: {
                isFamilyChannel: this.digitalSignage.isFamilyChannel,
                isResidentChannel: this.digitalSignage.isResidentChannel,
                pages: this.digitalSignage.pages,
                publishTo: this.selectedFacilitiesIds.filter(x => x !== doc.facilityId),
              }
            });
          }
        } else {
          const document = {
            channelName: this.digitalSignage.channelName,
            isFamilyChannel: this.digitalSignage.isFamilyChannel,
            isResidentChannel: this.digitalSignage.isResidentChannel,
            pages: this.digitalSignage.pages,
            facilityId: facilityId,
            publishTo: this.selectedFacilitiesIds.filter(x => x !== facilityId),
            parentDigitalSignageId: this.parentDigitalSignageId,
            orderIndex: null,
            isEnabled: false
          };

          await firebase.app().functions(getRegionName()).httpsCallable('utils-addOrgDocument')({
           orgId: this.$store.state.authModule.currentFacilityData.orgId,
           collectionName: 'digitalSignage',
           document: document
          });
        }
      }
    },
    async publish() {
      this.loading = true;

      await this.updateCurrentDigitalSignage();

      for(let i = 0; i < this.facilitiesToSelect.length; i++) {
        if(this.selectedFacilitiesIds.includes(this.facilitiesToSelect[i].id)) {
          await this.publishFacilityDigitalSignage(this.facilitiesToSelect[i].id);
        } else {
          await this.unPublishFacilityDigitalSignage(this.facilitiesToSelect[i].id);
        }
      }

      await this.$store.dispatch("getDigitalSignage", this.$route.params.id);

      this.$toast.open({
        message: this.$i18n.messages[this.$i18n.locale]['PublishDigitalSignage.DigitalSignageHasBeenPublished'],
        type: "success"
      });

      eventBus.$emit('refreshWingsDigitalSignage');

      this.loading = false;
    },
  }
}